import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ServiceAxios } from '../../../../services/ServiceEW';
import { ServiceValues } from '../../../../values/ServiceValues';
import Paper from '@material-ui/core/Paper';
import {useStyles} from './ArmaRegisterInfoStyles'
import WarningIcon from '@material-ui/icons/Warning';
import palette from '../../../../theme/palette';
import Alert from '@material-ui/lab/Alert';



function EmpresaRegisterInfo(props) {
  const {
    arma,
    setArma,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
  } = props;
  const [descricao, setDescricao] = useState(props.arma.razaoSocial);
  const [numeroArma, setNumeroArma] = useState(props.arma.nomeFantasia);
  const [numeroNotaFiscal, setnumeroNotaFiscal] = useState(props.arma.numeroNotaFiscal);
  const [idCalibre, setidCalibre] = useState(props.arma.idCalibre);
  const [openDialogFinish, setOpenDialogFinish] = React.useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [calibreSelecionado, setCalibreSelecionado] = useState(props.arma.calibre);
  const [calibres, setCalibres] = useState([]);
  const loadingCalibres = openAutocomplete && calibres.length === 0;
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();


  useEffect(() => {
    let active = true;
    if (!loadingCalibres) {
      return undefined;
    }
    (async () => {
      const params = {
        limit: 5000,
      };
      let dados = await api.get('calibres/', {params: params});
      dados = dados.data.result;
      if (active) {
        setCalibres(dados);
      }
    })();
    return () => {
      active = false;
    };
  }, [loadingCalibres]);


  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };


  function abrirDialogFinish (e) {
    setOpenDialogFinish(!openDialogFinish);
  }


  function errosForms() {
    setMessageSnack("Existem erros no formulário! Verifique e tente novamente");
    setTypeSnack('error');
    setShowMessageSnack(true);
  }

  function modificarValores(order, value){
    switch (order) {
      case 0:
        arma.descricao = value;
        setArma(arma);
        setDescricao(value);
        break;
      case 1:
        arma.numeroArma = value;
        setArma(arma);
        setNumeroArma(value);
        break;
      case 2:
        arma.numeroNotaFiscal = value;
        setArma(arma);
        setnumeroNotaFiscal(value);
        break;
      case 3:
        arma.idCalibre = value;
        setArma(arma);
        setidCalibre(value);
        break;
    }
    setArma(arma);
  }

  function aoModificarCalibre(event, calibre) {
    if(calibre){
      setCalibreSelecionado(calibre);
      arma.idCalibre = calibre.idCalibre;
      setArma(arma);
    }
    else{
      setCalibreSelecionado(null);
      arma.idCalibre = null;
      setArma(arma);
    }
  }

  return (
    <div>
      <CardHeader
        title="Arma"
        subheader="Informe as seguintes informações da arma"
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          {calibreSelecionado && !calibreSelecionado.permitido &&
          <Grid
            item
            md={12}
            xs={12}
          >
            <Alert
              severity="warning"
              variant="standard"
            >
              ATENÇÃO: O CALIBRE DESSA ARMA É CONSIDERADO RESTRITO
            </Alert>

          </Grid>
          }

          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Descrição"
              helperText="Insira a descrição da arma."
              margin="dense"
              name="razaoSocial"
              onChange={e => modificarValores(0, e.target.value)}
              value={arma.descricao}
              variant="outlined"
              validators={['required', 'maxStringLength:155']}
              errorMessages={['Informe a descrição!', 'Descrição muito longa!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Número da arma"
              helperText="Insira o número da arma."
              margin="dense"
              name="nomeFantasia"
              onChange={e => modificarValores(1, e.target.value)}
              value={arma.numeroArma}
              variant="outlined"
              validators={['required']}
              errorMessages={['Informe o número da arma!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Nº CRAF"
              helperText="Insira o Nº CRAF."
              margin="dense"
              name="email"
              onChange={e => modificarValores(2, e.target.value)}
              value={arma.numeroNotaFiscal}
              variant="outlined"
              validators={['required']}
              errorMessages={['Informe o Nº CRAF da arma!']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <Autocomplete
              size={'small'}
              id="autocomplete_calibre"
              open={openAutocomplete}
              value={calibreSelecionado}
              onOpen={() => {
                setOpenAutocomplete(true);
              }}
              onClose={() => {
                setOpenAutocomplete(false);
              }}
              onChange={aoModificarCalibre}
              getOptionSelected={(option, value) => option.descricao === option.descricao}
              getOptionLabel={option => option.descricao}
              options={calibres}
              loading={loadingCalibres}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Calibres"
                  fullWidth
                  margin={'dense'}
                  value={calibreSelecionado}
                  variant="outlined"
                  helperText={'Selecione o calibre da arma.'}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingCalibres ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

        </Grid>
      </CardContent>
      <Divider />

    </div>
  );
};

EmpresaRegisterInfo.propTypes = {
  className: PropTypes.string,
  arma: PropTypes.object.isRequired
};

export default EmpresaRegisterInfo;


